module.exports = __webpack_public_path__ + "img/close.286d52d6.png";